const STORAGE_KEY = "ytyard360.selectedSite.v1";

const normalizeSite = (site: string | null | undefined): string | null => {
  const trimmedSite = site?.trim();
  return trimmedSite || null;
};

export const loadSelectedSite = (): string | null => {
  try {
    return normalizeSite(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
};

export const saveSelectedSite = (site: string | null | undefined): void => {
  const normalizedSite = normalizeSite(site);
  if (normalizedSite === null) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, normalizedSite);
  } catch {
    return;
  }
};

export const resolveSelectedSite = (urlSite: string | null | undefined): string | null => {
  const normalizedUrlSite = normalizeSite(urlSite);
  if (normalizedUrlSite !== null) return normalizedUrlSite;

  return loadSelectedSite();
};
